import { NgModule } from '@angular/core';

import { CarruselAgendaComponent } from '../shared/ui/carrusel-agenda/carrusel-agenda.component';
import { CarruselCedulaComponent } from '../shared/ui/carrusel-cedula/carrusel-cedula.component';
import { DocumentUploadComponent } from '../shared/ui/document-upload/document-upload.component';
import { FooterComponent } from '../shared/ui/footer/footer.component';
import { HeaderComponent } from '../shared/ui/header/header.component';
import { MessagesComponent } from './ui/messages/messages.component';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvatarModule } from 'ngx-avatar';
import { NgxPopperModule } from 'ngx-popper';
import { CaracteresNumerosDirective } from 'src/app/global/directives/caracteres-numeros/caracteres-numeros.directive';
import { CaracteresDirective } from 'src/app/global/directives/caracteres/caracteres.directive';
import { FormatRutDirective } from 'src/app/global/directives/format-rut/format-rut.directive';
import { FormatSerieDirective } from 'src/app/global/directives/format-serie/format-serie.directive';
//import { MaxLengthDirective } from 'src/app/global/directives/length/max-length.directive';
import { MaxLengthDirective } from 'src/app/global/directives/MaxLength/max-length.directive';
import { CaracteresLargoDirective } from '../global/directives/caracteres-largo/caracteres-cargo';
import { MilesFormatDirective } from 'src/app/global/directives/milesFormat/miles-format.directive';
import { NumerosDirective } from 'src/app/global/directives/numeros/numeros.directive';
import { FileSizeFormatPipe } from 'src/app/global/pipes/file-size-format.pipe';
import { TipoVentaPipe } from 'src/app/global/pipes/tipoVenta/tipo-venta.pipe';
import { CiValidationComponent } from '../main/dialogs/ci-validation/ci-validation.component';
import { AutocompletarComponent } from './ui/autocompletar/autocompletar.component';
import { CodigoDescuentoComponent } from './ui/codigo-descuento/codigo-descuento.component';
import { ToastMessageComponent } from './ui/toast-message/toast-message.component';

@NgModule({
    declarations: [
        FormatRutDirective,
        FormatSerieDirective,
        CaracteresDirective,
        CaracteresNumerosDirective,
        NumerosDirective,
        MilesFormatDirective,
       // MaxLengthDirective,
        MaxLengthDirective,
        CaracteresLargoDirective,
        HeaderComponent,
        FooterComponent,
        CarruselCedulaComponent,
        CarruselAgendaComponent,
        MessagesComponent,
        DocumentUploadComponent,
        AutocompletarComponent,
        CodigoDescuentoComponent,
        FileSizeFormatPipe,
        TipoVentaPipe,
        ToastMessageComponent,
        CiValidationComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        AvatarModule,
        MatTooltipModule,
        NgxPopperModule.forRoot({}),
        MatCheckboxModule
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        CarruselCedulaComponent,
        CarruselAgendaComponent,
        MessagesComponent,
        DocumentUploadComponent,
        AutocompletarComponent,
        CodigoDescuentoComponent,
        FormatRutDirective,
        FormatSerieDirective,
        CaracteresDirective,
        CaracteresNumerosDirective,
        NumerosDirective,
        MilesFormatDirective,
       // MaxLengthDirective,
        MaxLengthDirective,
        CaracteresLargoDirective,
        FileSizeFormatPipe,
        TipoVentaPipe,
        ToastMessageComponent,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        CiValidationComponent
    ]
})
export class SharedModule { }
